const updateVariantUrl = (variantId: number): void => {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', String(variantId));
  window.history.replaceState({}, '', url);
};

export default updateVariantUrl;
